module.exports = __webpack_public_path__ + "img/operationGiveBack.56beb8e0.png";